import {cleanPipes, titleCase, replace} from '../../replacements.js';
import { Popup } from './Popup.js';

import { exportSpells, conditionsExport, diseasesExport, statusExport } from '../../constants.js';

const allHovers = [...exportSpells, ...conditionsExport, ...diseasesExport, ...statusExport]
const allHoversSeperated = [exportSpells, conditionsExport, diseasesExport, statusExport]

const popoverKeys = ["spell", "condition", "disease", "status", "hover"]
 
const getFormattedObj = (key, findKey, cPipes = false, tCase = true, bold = true) => {

    let sliceCount = findKey.length + 1
    let element;
    let valueName;
    let search;
    if(key.startsWith(findKey)) {
        element = key.slice(sliceCount)
        valueName = element
    }

    if(element) {
        if(cPipes) {
            let elObj = cleanPipes(element)
            search = elObj.name
            element = elObj.textToBeShown
            valueName = cleanPipes(valueName).textToBeShown
        }

        if(tCase) {
            element = element.toLowerCase()
            element = titleCase(element)
        }

        if(bold) {
            element = <strong>{element}</strong>
        }
    } else {
        return null
    }

    return {
        name: valueName,
        search: search,
        valueType: findKey,
        element: element
    }
}

const filterName = (elementObj) => {
    let indexOfType = popoverKeys.indexOf(elementObj.valueType)

    // Filter over specific or over all if homebrew
    if(indexOfType === 4) {
        return allHovers.filter(hoverItem => hoverItem.name.toLowerCase() === elementObj.search.toLowerCase());
    } else {
        return allHoversSeperated[indexOfType].filter(hoverItem => hoverItem.name.toLowerCase() === elementObj.search.toLowerCase());
    }
}

// Usage in a React Component
export const BoldifyReplace = ({ name, desc }) => {
    const str = (name || desc || "").toString();
    if(str === "") return null;

    const formatPart = (part) => {
        // This is not in replace() becuase they are special
        if (part.startsWith("{@h}")) { return <strong>Hit: {part.slice(4)}</strong>; } 
        if (part.startsWith("{@hit ")) { return <strong>+{part.slice(6).replace("}", "")}</strong>; } 
        // Note can have nested {@abc }
        if (part.startsWith("{@note ")) { 
            return <BoldifyReplace name={'Note: ' + part.slice(6).slice(0,-1)} />; 
        } 

        const match = part.match(/^\{@(.*?)\}$/);

        if (!match) return <span>{part}</span>;
        const key = match[1];
        let elementObj;
        elementObj = popoverKeys.map((popKey) => getFormattedObj(key, popKey, true)).find((obj) => obj !== null);
        
        // if its spell or condition, 
        if(elementObj) {
            if(popoverKeys.includes(elementObj.valueType)) {

                const hoverMatches = filterName(elementObj)
                // If no spell found, dont do popup and return regular string
                if(hoverMatches.length === 0) {
                    return elementObj.element
                }

                // If 'hover' its homebrew so search through everything for a match, else search specific
                return <Popup items={hoverMatches} elementObj={elementObj}/> 
            }
        } else {
            // if {@x} was found i.e. bold a replace,
            let replaced = replace(key)
            if(replaced)
                return replaced
            else {
                return <span>{key}!!!!!!!!!!!!!!</span>;
            }
        }
    };

    const formattedString = str.split(/(\{@h\}\d+ |\{@hit \d+\} to hit|\{@note.*\}|{@.*?\})/)
        .map((part, index) => <span key={"highlighted" + index}>
                {formatPart(part)}
            </span>
        ); 

    return <span className={desc ? 'infoDesc' : ''}>{formattedString}</span>;
};